import { apiConfig } from '@/services/api-config';

export default async function (cdTerritory: string) {
  return apiConfig
    .post(`api/Ticket/update-status-tickets-by-cdterritory?cdTerritory=${cdTerritory}`)
    .then((response) => response.data)
    .catch(() => []);
}
